import Ember from "ember";
export default {
  initialize(applicationInstance) {
    // Instantiation of the service starts the regular fetch of the new version.
    if (!Ember.testing) {
      applicationInstance.lookup("service:new-version");
    }
  }
};